<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="账号名称" v-model="searchForm.user_name" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="姓名" v-model="searchForm.alias_name" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="手机号" v-model="searchForm.mobile" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="微信号" v-model="searchForm.wechat" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-select v-model="searchForm.ins_id" placeholder="机构" clearable filterable style="width: 100%">
          <el-option v-for="item in companyOptions" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="success" icon="el-icon-plus" @click="handleAdd">新增师傅</el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <!-- <el-table-column prop="username" label="用户名" width="150"></el-table-column> -->
      <el-table-column prop="mobile" label="手机号" width="130"></el-table-column>
      <el-table-column prop="wechat" label="微信号" width="150"></el-table-column>
      <el-table-column prop="personalCode" label="身份证号" width="180"></el-table-column>
      <el-table-column prop="area" label="区域" width="200"></el-table-column>
      <el-table-column prop="address" label="详细地址" min-width="200"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" style="color: #f56c6c" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';

export default {
  name: 'EngineerList',
  components: {
    Pagination
  },
  data() {
    return {
      searchForm: {
        user_name: '',
        alias_name: '',
        mobile: '',
        wechat: '',
        ins_id: null
      },
      tableData: [],
      pagin: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      companyOptions: []
    };
  },
  mounted() {
    // 先加载机构列表，加载完成后会自动选择第一个机构并触发搜索
    this.loadCompanyList();
  },
  methods: {
    // 获取列表数据
    getList() {
      const params = {
        page: this.pagin.pageNum,
        limit: this.pagin.pageSize,
        user_type: 3,  // 固定为3，表示安装师傅
        user_name: this.searchForm.user_name || '',
        alias_name: this.searchForm.alias_name || '',
        mobile: this.searchForm.mobile || '',
        wechat: this.searchForm.wechat || '',
        mail: ''  // 邮箱字段，暂时不使用
      };

      // 如果选择了机构，则添加机构id参数
      if (this.searchForm.ins_id) {
        params.ins_id = this.searchForm.ins_id;
      }

      this.$http.get('/manage/user-info/page/', { params })
        .then(res => {
          if (res.data.code === 0) {
            this.tableData = res.data.data.records || [];
            this.pagin.total = res.data.data.total || 0;
          } else {
            this.$message.error(res.data.message || '获取数据失败');
          }
        })
        .catch(err => {
          this.$message.error('网络请求失败');
          console.error(err);
        });
    },

    // 加载机构列表
    loadCompanyList() {
      const params = {
        pageNum: 1,
        pageSize: 1000
      };

      this.$http.post('/manage/institution/list', params)
        .then(res => {
          if (res.data.code === 0) {
            this.companyOptions = res.data.data.records || [];
            // 如果机构列表不为空且当前没有选择机构，则默认选择第一个机构
            if (this.companyOptions.length > 0 && !this.searchForm.ins_id) {
              this.searchForm.ins_id = this.companyOptions[0].id;
              // 自动触发搜索
              this.getList();
            }
          } else {
            this.$message.error(res.data.message || '获取机构列表失败');
          }
        })
        .catch(err => {
          this.$message.error('网络请求失败');
          console.error(err);
        });
    },

    // 搜索
    search() {
      this.pagin.pageNum = 1;
      this.getList();
    },

    // 新增师傅
    handleAdd() {
      this.$router.push('/install/engineer/edit');
    },

    // 编辑师傅
    handleEdit(row) {
      // 将师傅数据存储到 Vuex，供编辑页面使用
      // 同时将当前筛选的机构ID也存储到数据中
      const editData = {
        ...row,
        ins_id: this.searchForm.ins_id || row.ins_id || row.insId // 优先使用搜索框的机构ID
      };
      this.$store.commit('setEditInfo', editData);
      this.$router.push({
        path: '/install/engineer/edit',
        query: { id: row.id }
      });
    },

    // 删除师傅
    handleDelete(row) {
      this.$confirm('确定删除该安装师傅吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/manage/user-info/delete/${row.id}`)
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success('删除成功');
              this.getList();
            } else {
              this.$message.error(res.data.message || '删除失败');
            }
            this.getList();

          })
          .catch(err => {
            this.$message.error('删除失败');
            console.error(err);
          });

        // Mock删除
        // this.$message.success('删除成功');
      }).catch(() => { });
    }
  }
};
</script>

<style scoped>
.search-add {
  margin-bottom: 20px;
}

.tableDel-Page {
  margin-top: 20px;
}
</style>
